import ga from "@mobi/libraries/analytics/ga"
import make from "@mobi/libraries/analytics/make"
import segment from "@mobi/libraries/analytics/segment"

const appTrackers = {
	trackSegmentPage: ({ event = "", data = null }) => {
		if (data) {
			segment.page(event, { ...data })
			return
		}
		segment.page(event)
	},

	trackSegmentEvent: ({ event = "", data = null }) => {
		if (data) {
			segment.track(event, { ...data })
			return
		}
		segment.track(event)
	},

	trackGaPage: (payload) => {
		ga.page(payload)
	},

	trackGaEvent: (payload) => {
		ga.track(payload)
	},

	trackMakePage: ({ event = "FormViewed", data = {}, options = {} }) => {
		make.track(event, data, options)
	},

	trackMakeEvent: ({ event = "", data = {}, options = {} }) => {
		make.track(event, data, options)
	}
}

export default appTrackers
